// 📁 utils/normalizePhoneNumber.js
export const normalizePhoneNumber = (num, country) => {
  if (!num || typeof num !== "string") return "";

  // Supprime tout sauf les chiffres
  const cleaned = num.replace(/\D/g, "");

  // Si déjà au format international
if (num.trim().startsWith("+")) {
  const cleaned = num.replace(/\D/g, "");

  switch (country) {
    case "FR":
      // Corrige +330... en +33...
      if (cleaned.startsWith("330")) {
        return `+33${cleaned.slice(3)}`;
      }
      return `+${cleaned}`;
    case "GB":
    case "UK":
      // Corrige +440... en +44...
      if (cleaned.startsWith("440")) {
        return `+44${cleaned.slice(3)}`;
      }
      return `+${cleaned}`;
    default:
      return `+${cleaned}`;
  }
}


  switch (country) {
    case "FR": // France
      return cleaned.startsWith("0")
        ? `+33${cleaned.slice(1)}`
        : `+33${cleaned}`;
    case "ES": // Espagne
      return cleaned.startsWith("0")
        ? `+34${cleaned.slice(1)}`
        : `+34${cleaned}`;
    case "UK": // Royaume-Uni
    case "GB":
      return cleaned.startsWith("0")
        ? `+44${cleaned.slice(1)}`
        : `+44${cleaned}`;
    case "IT": // Italie
      return cleaned.startsWith("0")
        ? `+39${cleaned.slice(1)}`
        : `+39${cleaned}`;
    case "CH": // Suisse
      return cleaned.startsWith("0")
        ? `+41${cleaned.slice(1)}`
        : `+41${cleaned}`;
    case "BE": // Belgique
      return cleaned.startsWith("0")
        ? `+32${cleaned.slice(1)}`
        : `+32${cleaned}`;
    case "DE": // Allemagne
      return cleaned.startsWith("0")
        ? `+49${cleaned.slice(1)}`
        : `+49${cleaned}`;
    case "US": // États-Unis
      return `+1${cleaned}`;
    case "IN": // Inde
      return cleaned.startsWith("0")
        ? `+91${cleaned.slice(1)}`
        : `+91${cleaned}`;
    case "MA": // Maroc
      return cleaned.startsWith("0")
        ? `+212${cleaned.slice(1)}`
        : `+212${cleaned}`;
    case "TN": // Tunisie
      return cleaned.startsWith("0")
        ? `+216${cleaned.slice(1)}`
        : `+216${cleaned}`;
    case "DZ": // Algérie
      return cleaned.startsWith("0")
        ? `+213${cleaned.slice(1)}`
        : `+213${cleaned}`;
    case "MX": // Mexique
      return cleaned.startsWith("0")
        ? `+52${cleaned.slice(1)}`
        : `+52${cleaned}`;
    case "EG": // Égypte
      return cleaned.startsWith("0")
        ? `+20${cleaned.slice(1)}`
        : `+20${cleaned}`;
    default:
      return `+${cleaned}`; // fallback : juste les chiffres
  }
};
